import React, { Component } from 'react';
import { selectSuiteFormData } from '../../store/selectors/suiteForm';
import { connect } from 'react-redux';
import './keyhandoff.scss';
import Form from '../../components/Form';
import Row from '../../components/Row';
import Col from '../../components/Col';
import SignatureCanvas from '../../components/SignatureCanvas';
import Button from '../../components/Button';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectValidation } from '../../store/selectors/Validation';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { bindActionCreators } from 'redux';
import { clearValidation } from '../../store/actions/validation';
import Loader from '../../components/Loader';
import { selectLoader } from '../../store/selectors/loader';
import AddSigneePopup from './AddSigneePopup';
import {
  fetchSuiteUsers,
  fetchkeypickupServiceRequests,
  fetchkeypickupImportantDocuments,
  clearkeyPickupDone,
} from '../../store/actions/suites';
import { selectSuiteUsers } from '../../store/selectors/suiteUsers';
import Textarea from '../../components/Textarea';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { variables } from '../../Tenants';
import SuiteExtraInfo from './SuiteExtraInfo';
import KeyPickupServiceRequestList from './KeyPickupServiceRequestList';
import KeyPickupDocuments from './KeyPickupDocuments';

class Keyhandoff extends Component {
  state = {
    suiteSignatureList: [],
    showAddForm: false,
    homeOwnersSigns: [],
    notes: '',
    isAddFormOpen: false,
  };
  componentDidMount() {
    const {
      onFetchkeypickupServiceRequests,
      onFetchkeypickupImportantDocuments,
      onClearkeyPickupDone,
      suiteFormData,
    } = this.props;
    onClearkeyPickupDone();
    onFetchkeypickupServiceRequests(suiteFormData.id);
    onFetchkeypickupImportantDocuments(suiteFormData.id);
  }
  handleSignature(image, signType, userType) {
    const { suiteFormData } = this.props;
    const { suiteSignatureList } = this.state;
    let signatures =
      suiteSignatureList && suiteSignatureList.length > 0
        ? suiteSignatureList
        : [];
    if (image !== null) {
      if (userType === 'Property Developer') {
        let params = {
          userId:
            suiteFormData.propertyManager && suiteFormData.propertyManager.id
              ? suiteFormData.propertyManager.id
              : null,
          role: 'Property Developer',
          signature: image,
          signType: signType,
        };
        signatures = [...signatures, params];
      } else {
        let params = {
          userId:
            suiteFormData.primaryContact && suiteFormData.primaryContact.id
              ? suiteFormData.primaryContact.id
              : null,
          role: 'Home Owner',
          signature: image,
          signType: signType,
        };
        signatures = [...signatures, params];
      }
      this.setState({ suiteSignatureList: signatures });
    } else {
      toast.error('🚫 Please enter a valid signature.', {
        autoClose: 10000,
        position: 'top-center',
      });
    }
  }

  handleHomeOwnerSignature = (image, signType, userId, type) => {
    const { homeOwnersSigns, suiteSignatureList } = this.state;
    let signs =
      homeOwnersSigns && homeOwnersSigns.length > 0 ? homeOwnersSigns : [];
    signs = signs.map((sign) => {
      if (type ? sign.email === userId : sign.userId === userId) {
        return { ...sign, signature: image, signType: signType };
      } else {
        return sign;
      }
    });
    this.setState({ homeOwnersSigns: signs });
  };

  removeSignature(role, userId, type) {
    const { suiteSignatureList, homeOwnersSigns } = this.state;
    if (userId && !type) {
      let signs = homeOwnersSigns.filter((sign) => sign.userId !== userId);
      let list = suiteSignatureList.filter((sn) => sn.userId !== userId);
      this.setState({ homeOwnersSigns: signs, suiteSignatureList: list });
    } else if (userId && type) {
      let signs = homeOwnersSigns.filter((sign) => sign.email !== userId);
      let list = suiteSignatureList.filter((sn) => sn.email !== userId);
      this.setState({ homeOwnersSigns: signs, suiteSignatureList: list });
    } else {
      let signatures = suiteSignatureList.filter((sign) => sign.role !== role);
      this.setState({ suiteSignatureList: signatures });
    }
  }

  handleSubmit = () => {
    const { suiteFormData, user } = this.props;
    const { homeOwnersSigns } = this.state;
    let signatures = homeOwnersSigns.filter((hs) => hs.signature);

    let params = {
      SuiteId: suiteFormData.id,
      LoginUserId: user.id,
      SignatureList: [...this.state.suiteSignatureList, ...signatures],
      notes: this.state.notes,
    };
    this.props.onSubmitKeyhandOffProcess(
      params,
      suiteFormData.propertyId,
      user.id,
      user.roles[0].role.name
    );
  };

  componentDidUpdate() {
    const { clearValidation, validation, onClose } = this.props;
    if (validation.status === true) {
      if (validation.message === 'KeyHandOff') {
        onClose();
        clearValidation();
      }
    }
  }

  addSignee = () => {
    this.props.onFetchSuiteUsers(this.props.suiteFormData.id, false);
    this.setState({ isAddFormOpen: true });
  };

  onSubmitPopup = (type, selectedHomeOwnerId, userType) => {
    const { suiteUsers } = this.props;
    let homeOwnersSigns = this.state.homeOwnersSigns;
    if (type === 'cancel') {
      this.setState({ isAddFormOpen: false });
    } else {
      if (userType === 'New') {
        homeOwnersSigns = [...homeOwnersSigns, selectedHomeOwnerId];
        this.setState({ homeOwnersSigns, isAddFormOpen: false });
      } else {
        let data = suiteUsers.filter(
          (user) => user.id === selectedHomeOwnerId
        )[0];
        let params = {
          userId: selectedHomeOwnerId,
          role: 'Home Owner',
          signature: '',
          firstname: data.firstname,
          lastname: data.lastname,
          signType: '',
        };
        homeOwnersSigns = [...homeOwnersSigns, params];
        this.setState({ homeOwnersSigns, isAddFormOpen: false });
      }
    }
  };

  render() {
    const { suiteFormData, onClose, loader, prLoader, keyPickup, user } =
      this.props;
    let signatures = this.state.suiteSignatureList;

    let homeOwnersSigns = this.state.homeOwnersSigns;
    let hoSignatures = homeOwnersSigns?.filter((hs) => hs.signature) || [];
    let propertyDeveloperSign =
      signatures.length > 0
        ? signatures.filter((sign) => sign.role === 'Property Developer')[0]
        : {};
    let homeOwnerSign =
      signatures.length > 0
        ? signatures.filter((sign) => sign.role === 'Home Owner')[0]
        : {};
    let homeownerName = '';
    let profileImage = '';

    if (suiteFormData.primaryContact?.id) {
      homeownerName =
        suiteFormData.primaryContact.firstname +
        ' ' +
        suiteFormData.primaryContact.lastname;
      profileImage = suiteFormData.primaryContact.profileImage
        ? suiteFormData.primaryContact.profileImage
        : '/assets/avatar.svg';
    } else if (suiteFormData.homeOwners?.id) {
      homeownerName =
        suiteFormData.homeOwners.firstname +
        ' ' +
        suiteFormData.homeOwners.lastname;
      profileImage = suiteFormData.homeOwners.profileImage
        ? suiteFormData.homeOwners.profileImage
        : '/assets/avatar.svg';
    }
    let developerName =
      suiteFormData.propertyManager && suiteFormData.propertyManager.id
        ? suiteFormData.propertyManager.firstname +
          ' ' +
          suiteFormData.propertyManager.lastname
        : '';

    return (
      <Form
        headline={'Key Pickup'}
        onClose={onClose}
        onExit={onClose}
        component={
          prLoader ? (
            <Loader center={true} />
          ) : suiteFormData && suiteFormData.id ? (
            <Row>
              {loader || keyPickup.isKeypickupLoading ? (
                <Loader center={true} position={true} />
              ) : null}
              <Col xs="12" md="12">
                <div
                  className="keyhand_process_details_row"
                  style={{ padding: 15 }}
                >
                  <Row mdCenter>
                    <Col xs="12" md="4">
                      <div className="col_inr">
                        <div className="keyhand_process_details_box">
                          <h4>Home Owner</h4>
                          <div className="keyhand_process_details_box_img d-flex align-items-center logo_style">
                            <img
                              className="avatar__image"
                              src={profileImage}
                              alt=""
                            />
                            <span>{homeownerName}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs="12" md="4">
                      <div className="col_inr">
                        <div className="keyhand_process_details_box">
                          <h4>{variables.Suite} Address</h4>
                          <div className="keyhand_process_details_box_img d-flex align-items-center">
                            <span>{suiteFormData.warrantyAddress}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs="12" md="4">
                      <div className="col_inr">
                        <div className="keyhand_process_details_box">
                          <h4>{variables.Suite} Number</h4>
                          <div className="keyhand_process_details_box_img d-flex align-items-center">
                            <span>{suiteFormData.number}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="keyhand_process_details_row instructions">
                  <Row>
                    <Col xs="12" md="6">
                      {suiteFormData.keyHandOffInstructions ? (
                        <div>
                          {
                            <div
                              dangerouslySetInnerHTML={{
                                __html: suiteFormData.keyHandOffInstructions,
                              }}
                            />
                          }
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col xs="12" md="6">
                      <div
                        className="ul_list_box1"
                        style={{ paddingLeft: '0px', marginLeft: '0px' }}
                      >
                        <ul>
                          {Array.isArray(suiteFormData?.parkingStalls) &&
                            suiteFormData.parkingStalls.length > 0 && (
                              <SuiteExtraInfo
                                title={'Parking Stalls'}
                                items={suiteFormData.parkingStalls}
                                message={'No parking slots.'}
                              />
                            )}
                          {Array.isArray(suiteFormData?.storageLockers) &&
                            suiteFormData.storageLockers.length > 0 && (
                              <SuiteExtraInfo
                                title={'Storage Lockers'}
                                items={suiteFormData.storageLockers}
                                message={'No storage lockers.'}
                              />
                            )}

                          <SuiteExtraInfo
                            title={'Key Fobs'}
                            items={suiteFormData.keyFobs}
                            message={'No key fobs.'}
                          />

                          <li>
                            Number of keys :{' '}
                            <span>{suiteFormData.numberOfKeys}</span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </div>
                {suiteFormData.suiteKeysAndValues &&
                  suiteFormData.suiteKeysAndValues.length > 0 && (
                    <>
                      <h3>Other Details</h3>
                      <Row>
                        {suiteFormData.suiteKeysAndValues.map((item, i) => {
                          return (
                            <Col xs="12" md="6" mdCenter>
                              <Row style={{ marginBottom: 20 }}>
                                <Col md="12" mdCenter>
                                  <span
                                    className=""
                                    style={{
                                      fontWeight: 'bold',
                                      marginRight: '8px',
                                    }}
                                    title={item.key}
                                  >
                                    {item.key}:
                                  </span>{' '}
                                  <span className="" title={item.value}>
                                    {item.value}
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                          );
                        })}
                      </Row>
                    </>
                  )}
                {keyPickup.serviceRequests &&
                  keyPickup.serviceRequests.length > 0 && (
                    <KeyPickupServiceRequestList
                      serviceRequests={keyPickup.serviceRequests}
                    />
                  )}
                {keyPickup.importantDocuments &&
                  keyPickup.importantDocuments.length > 0 && (
                    <KeyPickupDocuments
                      importantDocuments={keyPickup.importantDocuments}
                      user={user}
                    />
                  )}
                <Textarea
                  value={this.state.notes}
                  onChange={(e) => this.setState({ notes: e.target.value })}
                  label="NOTES"
                  placeholder="Notes"
                  block
                />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'right',
                    marginTop: 20,
                  }}
                >
                  <Button
                    color="complete_purple"
                    label="Add Signee"
                    onClick={() => this.addSignee()}
                    size="bar"
                  />
                </div>
                <div className="row keypickup">
                  <Col xs="12" md="6">
                    <Row mdCenter>
                      <Col md="8">
                        <h4>{developerName} Property Developer Signature</h4>
                      </Col>
                    </Row>
                    <SignatureCanvas
                      type={'keyhandoff'}
                      onInsert={(url, signType) => {
                        this.handleSignature(
                          url,
                          signType,
                          'Property Developer'
                        );
                      }}
                      signed={
                        propertyDeveloperSign && propertyDeveloperSign.signature
                          ? propertyDeveloperSign.signature
                          : ''
                      }
                      signType={
                        propertyDeveloperSign && propertyDeveloperSign.signType
                          ? propertyDeveloperSign.signType
                          : ''
                      }
                      remove={() => this.removeSignature('Property Developer')}
                      firstName={
                        suiteFormData.propertyManager &&
                        suiteFormData.propertyManager.firstname
                          ? suiteFormData.propertyManager.firstname
                          : ''
                      }
                      lastName={
                        suiteFormData.propertyManager &&
                        suiteFormData.propertyManager.lastname
                          ? suiteFormData.propertyManager.lastname
                          : ''
                      }
                      typeOfSign={'keyhandoff'}
                    />
                  </Col>
                  {suiteFormData.primaryContact &&
                    suiteFormData.primaryContact.id && (
                      <Col xs="12" md="6">
                        <Row mdCenter>
                          <Col md="8">
                            <h4>{homeownerName} Home Owner Signature</h4>
                          </Col>
                        </Row>
                        <SignatureCanvas
                          type={'keyhandoff'}
                          onInsert={(url, signType) => {
                            this.handleSignature(url, signType, 'Home Owner');
                          }}
                          signed={
                            homeOwnerSign && homeOwnerSign.signature
                              ? homeOwnerSign.signature
                              : ''
                          }
                          signType={
                            homeOwnerSign && homeOwnerSign.signType
                              ? homeOwnerSign.signType
                              : ''
                          }
                          remove={() => this.removeSignature('Home Owner')}
                          firstName={
                            suiteFormData.primaryContact &&
                            suiteFormData.primaryContact.firstname
                              ? suiteFormData.primaryContact.firstname
                              : ''
                          }
                          lastName={
                            suiteFormData.primaryContact &&
                            suiteFormData.primaryContact.lastname
                              ? suiteFormData.primaryContact.lastname
                              : ''
                          }
                          typeOfSign={'keyhandoff'}
                        />
                      </Col>
                    )}
                </div>
                <div className="row">
                  {homeOwnersSigns && homeOwnersSigns.length > 0
                    ? homeOwnersSigns.map((hs) => {
                        return (
                          <Col xs="12" md="6">
                            <Row mdCenter>
                              <Col md="8">
                                <h4>
                                  {hs.firstname + ' ' + hs.lastname} Home Owner
                                  Signature
                                </h4>
                              </Col>
                            </Row>
                            <SignatureCanvas
                              type={'keyhandoff'}
                              onInsert={(url, signType) => {
                                this.handleHomeOwnerSignature(
                                  url,
                                  signType,
                                  hs.userId ? hs.userId : hs.email,
                                  hs.email ? true : false
                                );
                              }}
                              signed={hs.signature ? hs.signature : ''}
                              signType={hs.signType ? hs.signType : ''}
                              remove={() =>
                                this.removeSignature(
                                  'Home Owner',
                                  hs.userId ? hs.userId : hs.email,
                                  hs.email ? true : false
                                )
                              }
                              firstName={hs.firstname}
                              lastName={hs.lastname}
                              typeOfSign={'keyhandoff'}
                            />
                          </Col>
                        );
                      })
                    : null}
                </div>
                {this.state.isAddFormOpen ? (
                  <AddSigneePopup onSubmitPopup={this.onSubmitPopup} />
                ) : null}
                <div
                  style={{
                    textAlign: 'center',
                    marginTop: 20,
                    position: 'fixed',
                    bottom: '0px',
                    left: '0px',
                    width: '100%',
                    background: 'rgb(255, 255, 255)',
                    padding: '15px',
                    boxShadow: 'rgba(0, 0, 0, 0.3) 0px 0px 0.3rem',
                  }}
                >
                  <Button
                    color="complete_purple"
                    label="Submit"
                    onClick={() => this.handleSubmit()}
                    size="bar"
                    disabled={
                      (signatures &&
                        signatures.length == 1 &&
                        hoSignatures.length >= 1) ||
                      (signatures && signatures.length == 2)
                        ? false
                        : true
                    }
                  />
                </div>
              </Col>
            </Row>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {variables.Suite} details fetching failed.
            </div>
          )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  suiteUsers: selectSuiteUsers(state),
  suiteFormData: selectSuiteFormData(state),
  user: selectAuthenticatedUser(state),
  validation: selectValidation(state),
  loader: selectFormLoader(state),
  prLoader: selectLoader(state),
  keyPickup: state.keyPickup,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchSuiteUsers: fetchSuiteUsers,
      clearValidation: clearValidation,
      onFetchkeypickupServiceRequests: fetchkeypickupServiceRequests,
      onFetchkeypickupImportantDocuments: fetchkeypickupImportantDocuments,
      onClearkeyPickupDone: clearkeyPickupDone,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Keyhandoff);
